import { Box, Dialog, Button, Typography } from '@mui/material';
import { styled } from '@mui/material/styles';
import Rating from '@mui/material/Rating';
import { DEFAULT_CAFE_IMG } from '../../../../../utils/constant';

const DialogBox = styled(Box)({
  width: '350px',
  height: '300px',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  background: '#FEFEFE',
  boxShadow: '0px 2px 2px rgba(0, 0, 0, 0.3)',
});

const InnerYellowFrame = styled('div')({
  width: '320px',
  height: '270px',
  border: '1px solid #AA9178',
});

const ProfileImage = styled(Box)(({ variant }) => ({
  display: 'flex',
  justifyContent: 'center',
  dropShadow: '0px 2px 2px rgba(0, 0, 0, 0.4)',
  marginTop: '16px',
  '& img': {
    width: '100px',
    height: '100px',
    objectFit: 'cover',
  },
}));

const ContentText = styled(Box)({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  fontFamily: 'Raleway',
  fontWeight: '400',
  fontSize: '16px',
  lineHeight: '19px',
  marginTop: '16px',
  color: '#000000',
});

const ShopName = styled(Box)({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  fontFamily: 'Raleway',
  fontWeight: '400',
  fontSize: '16px',
  lineHeight: '19px',
  color: '#000000',
});

const CafeName = styled(Typography)({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  fontFamily: 'Fjalla One',
  fontWeight: '700',
  fontSize: '17px',
  lineHeight: '19px',
  color: '#000000',
  marginTop: '5px',
  marginLeft: '3px',
  marginRight: '3px',
});
const RatingStarContainer = styled('div')({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  marginTop: '12px',
});
const ButtonGroup = styled(Box)({
  display: 'flex',
  flexDirection: 'column',
  marginTop: '18px',
  alignItems: 'center',
});

const CancelButton = styled(Button)({
  width: '41px',
  height: '20px',
  fontFamily: 'Fjalla One',
  fontSize: '16px',
  fontWeight: 400,
  lineHeight: '20px',
  border: 'none',
  backgroundColor: 'white',
  color: '#000000',
});

export default function RatingDialog({
  open,
  onClose,
  img,
  name,
  currentUserNum,
  cancelHandler,
  handleRating,
}) {
  const cafeImage = img.length != 0 ? img[0].url : DEFAULT_CAFE_IMG;
  return (
    <Dialog PaperProps={{ style: { borderRadius: 0 } }} onClose={onClose} open={open}>
      <DialogBox>
        <InnerYellowFrame>
          <ProfileImage>
            <img src={cafeImage} alt={name} />
          </ProfileImage>
          <ContentText>How many stars will you give to</ContentText>
          <ShopName>
            <span>@ </span>
            <CafeName> {name}</CafeName>
            <span>?</span>
          </ShopName>
          <RatingStarContainer>
            <Rating name="customized-10" value={currentUserNum} max={10} onChange={handleRating} />
          </RatingStarContainer>
          <ButtonGroup>
            <CancelButton onClick={cancelHandler}>CANCEL</CancelButton>
          </ButtonGroup>
        </InnerYellowFrame>
      </DialogBox>
    </Dialog>
  );
}
